import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import CustomerOrdersTable from "pages/vendor/Customers/components/CustomerOrdersTable"
import { useTranslation } from "react-i18next"

export interface CustomerOrder {
  customerName: string
  id: string
  purchaseType: "One Time Purchase" | "Based On Coupon"
  area: string
  averageOrderValue: string
  received: string
  status: "Active" | "In Active"
}
export const customerOrdersData: CustomerOrder[] = [
  {
    customerName: "Ahmed Ali",
    id: "ID-145876",
    purchaseType: "One Time Purchase",
    area: "Doha",
    averageOrderValue: "150 QAR",
    received: "3 Product",
    status: "Active",
  },
  {
    customerName: "Emily Davis",
    id: "ID-145881",
    purchaseType: "Based On Coupon",
    area: "Al Rayyan",
    averageOrderValue: "150 QAR",
    received: "8 Bottles",
    status: "In Active",
  },
  {
    customerName: "Maria Garcia",
    id: "ID-145879",
    purchaseType: "Based On Coupon",
    area: "Al Wakrah",
    averageOrderValue: "150 QAR",
    received: "3 Bottles",
    status: "Active",
  },
  {
    customerName: "James Brown",
    id: "ID-145880",
    purchaseType: "Based On Coupon",
    area: "Doha",
    averageOrderValue: "150 QAR",
    received: "2 Bottles",
    status: "Active",
  },
  {
    customerName: "Sofia Kim",
    id: "ID-145877",
    purchaseType: "Based On Coupon",
    area: "Al Khor",
    averageOrderValue: "150 QAR",
    received: "4 Bottles",
    status: "Active",
  },
  {
    customerName: "Liam Smith",
    id: "ID-145878",
    purchaseType: "Based On Coupon",
    area: "Al Rayyan",
    averageOrderValue: "150 QAR",
    received: "5 Bottles",
    status: "In Active",
  },
  {
    customerName: "Ahmed Ali",
    id: "ID-145876",
    purchaseType: "One Time Purchase",
    area: "Doha",
    averageOrderValue: "150 QAR",
    received: "6 Bottles",
    status: "Active",
  },
]

export const NewThisMonth = () => {
  const { t } = useTranslation()

  const [checkedCustomersOrders, setCheckedCustomersOrders] = useState<
    CustomerOrder[]
  >([])
  const [customersOrders, setCustomersOrders] = useState<CustomerOrder[]>([])

  useEffect(() => {
    setCustomersOrders(customerOrdersData)
  }, [])

  const isAllChecked = useMemo(() => {
    return (
      customersOrders.length > 0 &&
      checkedCustomersOrders.length === customersOrders.length
    )
  }, [customersOrders, checkedCustomersOrders])

  const togglecheckedCustomerOrderHandler = useCallback(
    (customer: CustomerOrder) => {
      setCheckedCustomersOrders(prev =>
        prev.includes(customer)
          ? prev.filter(c => c !== customer)
          : [...prev, customer]
      )
    },
    []
  )

  const toggleAllCustomersOrders = useCallback(() => {
    setCheckedCustomersOrders(isAllChecked ? [] : customersOrders)
  }, [isAllChecked, customersOrders])

  const toggleActiveCustomerOrders = useCallback(
    (customer: CustomerOrder) => {
      setCustomersOrders(prev =>
        prev.map(c =>
          c.id === customer.id
            ? {
                ...c,
                status: c.status === "Active" ? "In Active" : "Active",
              }
            : c
        )
      )
    },
    [customersOrders]
  )

  return (
    <div className="page-content">
      <Breadcrumbs
        title={t("dashboard_dashboard")}
        breadcrumbItem={t("customers_customers")}
        subBreadcrumbItem={t("customers_newThisMonth")}
      />
      <div className="container-fluid">
        <CustomerOrdersTable
          customersOrders={customersOrders}
          isAllChecked={isAllChecked}
          checkedCustomersOrders={checkedCustomersOrders}
          toggleAllCustomersOrders={toggleAllCustomersOrders}
          toggleActiveCustomerOrders={toggleActiveCustomerOrders}
          togglecheckedCustomerOrdersHandler={togglecheckedCustomerOrderHandler}
        />
      </div>
    </div>
  )
}
